import React from "react";

const About = () => {
  return (
    <div class="main-other">
      <section class="body container">
        <div class="content-body d-flex justify-content-center align-items-center ht-500">
          <div class="shadow p-4 rounded bg-white">
            <h1 class="center content-header">About Us</h1>
            <p class="content-text">At Nimble, we're redefining the shopping experience. Our vision is to make your purchases as quick and effortless as possible.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
